import React from 'react';
import Image from 'next/image';
import Link from "next/link";

const Hero = () => (
    <section className="bg-white text-center px-10">
        <div className="container mx-auto">
            <div className="flex justify-center -mb-10" style={{ minHeight: "400px" }}>
                <Image 
                    src="/images/10-finger-schreiben-schreibmaschine.png" 
                    alt="10 finger schreiben an der Schreibmaschine" 
                    width={600} 
                    height={400} 
                    priority={true}
                    placeholder="blur"
                    blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNk+P+/HgAFdwI2QVQCwwAAAABJRU5ErkJggg=="
                />
            </div>
            <h2 className="text-left text-5xl font-semibold mb-4" style={{ fontFamily: '"Courier Prime", monospace' }}>
                10 Finger schreiben lernen Online<span className="blinking-cursor">|</span>
            </h2>
            <p className="text-left text-lg mb-4">
                Lerne auf 10-finger-schreiben-lernen.de das effiziente Zehnfingersystem. Unser kostenloser Online-Tipptrainer funktioniert ohne Installation direkt in deinem Browser. Mit unserer Hilfe kannst du das blinde Tastschreiben schnell meistern, deine Tippgeschwindigkeit erhöhen und entspannter am Computer arbeiten.
            </p>
            <Link href="/einfuehrung" className="bg-blue-600 text-white py-2 px-4 rounded font-semibold hover:bg-blue-700 transition duration-300 inline-block">
                Jetzt trainieren
            </Link>
        </div>
    </section>
);

export default Hero;
